import { NewReleases } from "@mui/icons-material";
import { Button, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";
import { IconButton } from "@/components/deprecated-mui/icon-button";
import { useFrillWidget } from "@/hooks/use-frill-widget/use-frill-widget";
import { FRILL_WIDGET_CLASS_NAME } from "./constants";
import "./frill-badge.scss";

interface ProductUpdateButtonProps {
    buttonText?: string; // Render a button with the text, otherwise render an icon button with a badge
}

export function ProductUpdateButton({ buttonText }: ProductUpdateButtonProps) {
    const { t } = useTranslation(NAMESPACES.FEATURES.PRODUCT_UPDATE, { keyPrefix: "product-update-button" });
    const widgetRef = useFrillWidget();

    return (
        <>
            {buttonText ? (
                <MenuItem
                    component={Button}
                    key={`ProductUpdateMenu`}
                    onClick={() => widgetRef.current?.open()}
                    sx={{
                        textTransform: "none",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 3,
                    }}
                >
                    <div className={`${FRILL_WIDGET_CLASS_NAME} product-updates-button-text`}>{buttonText}</div>
                </MenuItem>
            ) : (
                <IconButton
                    className={FRILL_WIDGET_CLASS_NAME}
                    badgeSx={{ top: 2, right: -12 }}
                    icon={<NewReleases />}
                    title={t("title")}
                    onClick={() => widgetRef.current?.open()}
                />
            )}
        </>
    );
}
